export default __webpack_public_path__ + "static/media/bbps_logo.202bd89a.png";